export const messages = {
  en: {
    user: {
      vipNamePlaceholder: 'Enter member name',
      vipTelPlaceholder: 'Enter member phone',
      vip: {
        title: 'Members',
        id: 'Member ID',
        name: 'Member Name',
        phone: 'Phone',
        gender: 'Gender',
        genderOptions: {
          male: 'Male',
          female: 'Female'
        },
        level: 'Member Level',
        birthday: 'Birthday',
        startTime: 'Start Time',
        endTime: 'End Time',
        createTime: 'Create Time',
        operations: 'Operations'
      }
    }
  },
  zh: {
    user: {
      vipNamePlaceholder: '请输入会员名称',
      vipTelPlaceholder: '请输入会员电话',
      vip: {
        title: '会员管理',
        id: '会员编号',
        name: '会员名称',
        phone: '会员电话',
        gender: '性别',
        genderOptions: {
          male: '男',
          female: '女'
        },
        level: '会员等级',
        birthday: '会员生日',
        startTime: '开始时间',
        endTime: '结束时间',
        createTime: '创建时间',
        operations: '操作'
      }
    }
  }
}